"use client";
import { useSession } from "next-auth/react";
import type { ReactNode } from "react";
import { createContext, useCallback, useContext, useMemo } from "react";
import { useSessionStorage } from "utils";

type ProviderContextType = {
  providerId: string;
  setProviderId: (id: string) => void;
};

const ProviderContext = createContext({} as ProviderContextType);

export function useProviderContext() {
  return useContext(ProviderContext);
}

interface IProviderProviderProps {
  children: ReactNode;
}

export function ProviderProvider({ children }: IProviderProviderProps) {
  const { data: session } = useSession();
  const [selectedProviderId, setSelectedProviderId] = useSessionStorage(
    "selectedProvider",
    // @ts-ignore - type not defined but it is defined
    session?.user?.providerId ?? ""
  );

  const setProviderId = useCallback((providerId: string) => {
    setSelectedProviderId(providerId);
  }, [setSelectedProviderId]);

  const contextValue = useMemo(() => ({
    providerId: selectedProviderId,
    setProviderId,
  }), [selectedProviderId, setProviderId]);

  return (
    <ProviderContext.Provider value={contextValue}>
      {children}
    </ProviderContext.Provider>
  );
}